import './i18next'
import 'iframe-resizer/js/iframeResizer.contentWindow'
import 'moment/locale/en-ca'
import 'moment/locale/fr'

import i18next from 'i18next'
import moment from 'moment'
import queryString from 'query-string'
import React, {Suspense, useEffect, useState} from 'react'
import {Redirect, Route, RouteComponentProps, withRouter} from 'react-router-dom'
import styled from 'styled-components'

// import { isLoggedIn } from './common/auth'
import LoadingOverlay from './common/components/LoadingOverlay'
import {routes} from './common/routes'
import ApplicationFlowContextProvider from './contexts/ApplicationFlowContextProvider'
import CartContextProvider from './contexts/CartContextProvider'
import NavigationContextProvider from './contexts/NavigationContextProvider'
import ThemeContextProvider from './contexts/ThemeProvider'
import AddToWishlistButton from './views/addToWishlistButton/AddToWishlistButton'
import AddToWishlistListener from './views/addToWishListListener/addToWishListListener'
import ProfileIcon from './views/profileIcon/ProfileIcon'
import Memberships from './views/memberships/Memberships'
import Calendar from './views/calendar/Calendar';
import TreeView from './views/treeView/TreeView';
import CollapseView from './views/collapseView/CollapseView';
import {darkenLightColor} from "./common/colors";
import RentableUnavailability from './views/RentableUnavailability/RentableUnavailability';
import {getCssByOrganizationId} from './common/requests'
import {Helmet} from "react-helmet";
import {FilterModes, IFilterMode} from "./views/calendar/types";

const Authentication = React.lazy(() => import('./views/authentication/Authentication'));
const GroupsAndOffers = React.lazy(() => import('./views/groupsAndOffers/GroupsAndOffers'));
const ShoppingCart = React.lazy(() => import('./views/cart/ShoppingCart'));
const SmartCartIcon = React.lazy(() => import('./views/smartCartIcon/SmartCartIcon'));
const Wishlist = React.lazy(() => import('./views/wishlist/Wishlist'));

const DEFAULT_CART_URL = '#';
const DEFAULT_PROFILE_URL = 'https://www.qidigo.com/dashboard/informations';

const InvalidParams = () => <div>Invalid params</div>

const ActivitySubscription: React.FC<RouteComponentProps> = ({ location }) => {
    const [initialLoading, setInitialLoading] = useState(true);
    // const [loggedIn, setLoggedIn] = useState(false);

    //PARAMS RECEIVED FROM USER
    const [language, setLanguage] = useState<'fr' | 'en'>('fr');
    const [primaryColor, setPrimaryColor] = useState<string | undefined>(undefined);
    const [secondaryColor, setSecondaryColor] = useState<string | undefined>(undefined);
    const [activityId, setActivityId] = useState<number | null>(null);
    const [programId, setProgramId] = useState<number | null>(null);
    const [filterByProgramIds, setFilterByProgramIds] = useState<number[] | null>(null);
    const [text, setText] = useState(null);
    const [groupIds, setGroupIds] = useState(null);
    const [cartUrl, setCartUrl] = useState(DEFAULT_CART_URL);
    const [addSubscriptionUrl, setAddSubscriptionUrl] = useState<string | null>(null);
    const [profileUrl, setProfileUrl] = useState(DEFAULT_PROFILE_URL);
    const [organizationId, setOrganizationId] = useState<number | null>(null);
    const [organizationSlug, setOrganizationSlug] = useState<string | null>(null);
    const [shopUrl, setShopUrl] = useState<string | null>(null);
    const [shouldHideActivityDescription, setShouldHideActivityDescription] = useState<boolean>(false);
    const [altTranslationKeys, setAltTranslationKeys] = useState<string[]>([]);
    const [gtag, setGTag] = useState<string | null>(null);
    const [filterByCategoryIds, setFilterByCategoryIds] = useState<number[]>([]);
    const [filterByCategoryMode, setFilterByCategoryMode] = useState<IFilterMode>({mode: FilterModes.in});
    const [css, setCss] = useState('')

    useEffect(() => {
        const initializeApp = async (): Promise<void> => {
            if (language === 'fr') {
                moment.locale('fr')
            } else {
                await i18next.changeLanguage(language);
                moment.locale('en-ca');
            }
            // setLoggedIn(await isLoggedIn());
            setInitialLoading(false);
        };
        initializeApp();
    }, [language]);

    useEffect(() => {

        const urlParams = queryString.parse(location.search) as any;
        if (altTranslationKeys.length === 0 && Boolean(urlParams.altTranlationKeys)) {
            setAltTranslationKeys(urlParams.altTranlationKeys.split(','))
        }

        if (!!urlParams.language && (urlParams.language === 'fr' || urlParams.language === 'en')) setLanguage(urlParams.language);
        if (primaryColor === undefined) setPrimaryColor(!!urlParams.primaryColor ? '#' + urlParams.primaryColor : '#F40B17');
        if (secondaryColor === undefined) setSecondaryColor(!!urlParams.secondaryColor ? '#' + urlParams.secondaryColor : (!!urlParams.primaryColor ? '#' + (darkenLightColor(urlParams.primaryColor, 60))  : '#aa0810'));
        if (text === null) setText(!!urlParams.text ? urlParams.text : 'ADD_TO_WISHLIST');
        if (activityId === null && !!urlParams.activityId) setActivityId(Number(urlParams.activityId));
        if (programId === null && !!urlParams.programId) setProgramId(Number(urlParams.programId));
        if (filterByProgramIds === null && (!!urlParams.filterByProgramIds || !!urlParams.programId)) {
            setFilterByProgramIds(
                urlParams.filterByProgramIds
                    ? urlParams.filterByProgramIds.split(',').map((id: { trim: () => string;}) => parseInt(id.trim(), 10))
                    : [urlParams.programId]
            );
        }
        if (groupIds === null && !!urlParams.group_ids) setGroupIds(urlParams.group_ids);
        if (cartUrl === DEFAULT_CART_URL && !!urlParams.shoppingCartUrl) setCartUrl(urlParams.shoppingCartUrl);
        if (profileUrl === DEFAULT_PROFILE_URL && !!urlParams.profileUrl) setProfileUrl(urlParams.profileUrl);
        if (organizationId === null && !!urlParams.organizationId) setOrganizationId(Number(urlParams.organizationId));
        if (organizationSlug === null && !!urlParams.organizationSlug) setOrganizationSlug(urlParams.organizationSlug);
        if (urlParams.shouldHideActivityDescription && urlParams.shouldHideActivityDescription !== "0") setShouldHideActivityDescription(true);
        if (shopUrl === null && !!urlParams.shopUrl) setShopUrl(urlParams.shopUrl);
        if (addSubscriptionUrl === null && !!urlParams.addSubscriptionUrl) setAddSubscriptionUrl(urlParams.addSubscriptionUrl);
        if (gtag === null && !!urlParams.gtag) setGTag(urlParams.gtag);
        if (filterByCategoryIds.length === 0 && !!urlParams.filterByCategoryIds) {
            setFilterByCategoryIds(
                urlParams.filterByCategoryIds.split(',').map((id: { trim: () => string;}) => parseInt(id.trim(), 10))
            );

            if (!!urlParams.filterByCategoryMode) setFilterByCategoryMode(
                {mode: urlParams.filterByCategoryMode === 'out' ? FilterModes.out : FilterModes.in}
            );
        }
    }, [altTranslationKeys, location, activityId, cartUrl, groupIds, organizationId, organizationSlug, primaryColor, secondaryColor, profileUrl, programId, shopUrl, text, gtag])

    useEffect(() => {
        if (organizationId !== null) {
            getCssByOrganizationId(organizationId)
                .then(setCss)
        }
    }, [organizationId])

    return (
        <App>
            <Helmet>
                <style>{css}</style>
            </Helmet>
            {
                !initialLoading && (
                    <ThemeContextProvider primary={primaryColor} secondary={secondaryColor}>
                        <ApplicationFlowContextProvider organizationId={organizationId}>
                            <CartContextProvider>
                                <Route render={() => {
                                    return (
                                        <>
                                            <Suspense fallback={<LoadingOverlay />}>
                                                <Route render={({ history }) => (
                                                    <NavigationContextProvider shoppingCartUrl={cartUrl}>
                                                        <>
                                                            <Route exact path="/" render={() => <Redirect to={routes.groupsAndOffers} />} />
                                                            <Route path={routes.groupsAndOffers} render={(routeProps) => {
                                                                if (activityId === null) {
                                                                    return <InvalidParams />
                                                                }
                                                                return <GroupsAndOffers activityId={activityId} gtag={gtag} {...routeProps} />
                                                            }} />
                                                            <Route
                                                                path={routes.authentication}
                                                                render={props => <Authentication {...props} />}
                                                            />
                                                        </>
                                                    </NavigationContextProvider>)
                                                } />
                                                <Route
                                                    path={routes.shoppingCart}
                                                    render={(routeProps) =>
                                                        <ShoppingCart gtag={gtag} {...routeProps} />
                                                    }
                                                />
                                            </Suspense>
                                            <Suspense fallback={<div>...</div>}>
                                                <Route path={routes.smartCartIcon} render={() => <SmartCartIcon cartUrl={cartUrl} />} />
                                                <Route path={routes.profileIcon} render={() => <ProfileIcon profileUrl={profileUrl} />} />
                                                <Route path={routes.addToWishlist} render={() => {
                                                    if (organizationId === null || activityId === null || programId === null) {
                                                        return <InvalidParams />
                                                    }
                                                    return (
                                                        <AddToWishlistButton
                                                            organization_id={organizationId}
                                                            group_ids={groupIds || undefined}
                                                            activity_id={activityId}
                                                            program_id={programId}
                                                            text={text || undefined}
                                                            cartUrl={cartUrl}
                                                        />
                                                    )
                                                }} />
                                                <Route path={routes.addToWishlistListener} render={() => {
                                                    if (organizationId === null) {
                                                        return <InvalidParams />
                                                    }
                                                    return <AddToWishlistListener organization_id={organizationId} />
                                                }} />
                                                <Route
                                                    path={routes.wishlist}
                                                    render={() => {
                                                        if (organizationId === null) {
                                                            return <InvalidParams />
                                                        }
                                                        return (
                                                            <>
                                                                <Wishlist shouldHideActivityDescription={shouldHideActivityDescription} organizationId={organizationId} shopUrl={shopUrl} gtag={gtag} />
                                                            </>
                                                        )
                                                    }}
                                                />
                                                <Route
                                                    path={routes.memberships}
                                                    render={() => {
                                                        if (organizationId === null) {
                                                            return <InvalidParams />
                                                        }
                                                        return (
                                                            <Memberships
                                                                organizationId={organizationId}
                                                                organizationSlug={organizationSlug || undefined}
                                                                altTranslationKeys={altTranslationKeys}
                                                                shopUrl={shopUrl}
                                                                gtag={gtag}
                                                            />
                                                        )
                                                    }}
                                                />
                                                <Route
                                                    path={routes.calendar}
                                                    render={() => {
                                                        if (organizationId === null || filterByProgramIds === null) {
                                                            return <InvalidParams />
                                                        }

                                                        return (
                                                            <Calendar
                                                                organizationId={organizationId}
                                                                organizationSlug={organizationSlug || undefined}
                                                                programIds={filterByProgramIds}
                                                                shopUrl={shopUrl || undefined}
                                                                filterByCategoryIds={filterByCategoryIds}
                                                                filterByCategoryMode={filterByCategoryMode}
                                                            />
                                                        )
                                                    }}
                                                />
                                                <Route
                                                    path={routes.treeView}
                                                    render={() => {
                                                        if (organizationId === null || filterByProgramIds === null) {
                                                            return <InvalidParams />
                                                        }
                                                        return (
                                                            <TreeView
                                                                organizationId={organizationId}
                                                                organizationSlug={organizationSlug || undefined}
                                                                programIds={filterByProgramIds}
                                                                shopUrl={shopUrl || undefined}
                                                            />
                                                        )
                                                    }}
                                                />
                                                <Route
                                                    path={routes.collapseView}
                                                    render={() => {
                                                        if (organizationId === null || filterByProgramIds === null) {
                                                            return <InvalidParams />
                                                        }
                                                        return (
                                                            <CollapseView
                                                                organizationId={organizationId}
                                                                organizationSlug={organizationSlug || undefined}
                                                                programIds={filterByProgramIds}
                                                                shopUrl={shopUrl || undefined}
                                                                filterByCategoryIds={filterByCategoryIds}
                                                                filterByCategoryMode={filterByCategoryMode}
                                                            />
                                                        )
                                                    }}
                                                />
                                                <Route
                                                    path={routes.availability}
                                                    render={() => {
                                                        if (organizationId === null) {
                                                            return <InvalidParams />
                                                        }
                                                        return (
                                                            <RentableUnavailability
                                                                organizationId={organizationId}
                                                                organizationSlug={organizationSlug || undefined}
                                                                shopUrl={shopUrl || undefined}
                                                                language={language}
                                                                gtag={gtag}
                                                            />
                                                        )
                                                    }}
                                                />
                                            </Suspense>
                                        </>
                                    )
                                }} />
                            </CartContextProvider>
                        </ApplicationFlowContextProvider>
                    </ThemeContextProvider>
                )
            }
        </App>
    )
};

const App = styled.div`
  position: relative;
  font-family: Helvetica, sans-serif;
  width: 100%;
  background-color:#FFF;
`;

export default withRouter(ActivitySubscription);
